<template>
  <v-scale-transition origin="center">
    <v-btn
      color="primary"
      fab
      bottom
      right
      fixed
      @click.stop="$emit('click')"
    >
      <v-icon>{{ icon }}</v-icon>
    </v-btn>
  </v-scale-transition>
</template>

<script>
export default {
  name: 'PrimaryActionButton',

  props: {
    icon: {
      type: String,
      default: 'add',
    },
  },
};
</script>
